import { useTranslation } from 'react-i18next'

import { REQUEST_ENTITY } from '../../../constants/entity'
import { EntityStatus, getEntityStatuses } from '../../Entity'
import Text from '../../Text'

function StatusListItemContent({
  entity = REQUEST_ENTITY,
  item,
  status,
  statuses,
}) {
  const { t } = useTranslation()

  const entityStatuses = statuses ?? getEntityStatuses(entity)

  return item?.value === null ? (
    <Text>{item.is_persistent ? t(item.label) : item.label}</Text>
  ) : (
    <EntityStatus id={status} statuses={entityStatuses} />
  )
}

export default StatusListItemContent
